import React from 'react';
import { useAtom } from 'jotai';
import { Header } from 'Components/Common';
import {
  ticketAtom,
} from 'Atoms/Ticket';
import { staticDataAtom } from 'Atoms/Common';
import { formattingDigitCurrency, getTicketAliasFromPathname, CallApi } from 'utils';
import {
  useParams,
  useHistory
} from "react-router-dom";
import RequestTicketForm from './RequestTicketForm';
import RequestTicketAction from './RequestTicketAction';
import RequestTicketSuccess from './RequestTicketSuccess';


const RequestTicket = () => {
  const [ticket] = useAtom(ticketAtom);
  const history = useHistory();
  const { idPayment } = useParams();
  const [staticData, setStaticData] = useAtom(staticDataAtom);
  const [emailValid, setEmailValid] = React.useState(true);
  const [ticketRequested, setTicketRequested] = React.useState(false);
  console.log(ticket)

  const currency = staticData?.currency;
  const amountFormatting = (amount) => {
    return formattingDigitCurrency(
      amount,
      currency?.countryCode,
      currency?.labelCode,
    );
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const payment = ticket?.order?.payments?.done?.items.find(item => item.id == idPayment);
  if (!payment && ticket?.order?.payments?.done?.items.length) {
    const pathname = window?.location?.pathname;
    const ticketAlias = getTicketAliasFromPathname(pathname);
    history.push(`/ticket/:${ticketAlias}`)
  }

  const handleAskTicket = async (e, email) => {
    e.preventDefault();
    if (validateEmail(email)) {
      const pathname = window?.location?.pathname;
        const ticketAlias = getTicketAliasFromPathname(pathname);
        const { REACT_APP_TOKEN_API } = process.env;
        let header = {
          Authorization: [REACT_APP_TOKEN_API],
          ticketAlias: ticketAlias,
          paymentId: idPayment,
          email: email
        };
        const result = await CallApi("get", "ticket/demand", "", "", header);
        if (result && result[0] && result[0].ok) {
          setTicketRequested(true);
        }
        console.log(result)
    } else {
      setEmailValid(false);
    }
  }

  const ScreenSwitcher = () => {
    //after submit email
    if(ticketRequested) {
      return <RequestTicketSuccess/>
    }
    //if ticket are available
    if (ticket.order.ticketAvailableToPrint) {
      return <RequestTicketAction ticketId={ticket.id} paymentId={idPayment} payment={payment} />
    }
    //default : email form to send ticket
    return <RequestTicketForm handleAskTicket={handleAskTicket} emailValid={emailValid} />
  }


  return payment ? (
    <>
    <Header
        actions={{
          prev: {
            label: `${payment.method} (${amountFormatting(payment.amount)})`,
            path: `/ticket/:${ticket.id}`,
            icon: 'return',
          },
        }}
      ></Header>
      <ScreenSwitcher/>
    </>
  ) : null;
};

export default RequestTicket;
